<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <img class="logo" src="../assets/logo.png" alt="Mindy Teams Logo"/>
      </div>

      <form @submit.prevent="submitForm" class="login-form">
        <div class="field">
          <label class="label">{{ $t('username') }}:</label>
          <div class="control">
            <input type="text" name="username" class="input" v-model="username" required>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('password') }}:</label>
          <div class="control">
            <input type="password" name="password" class="input" v-model="password" required>
          </div>
        </div>

        <div class="alert alert-danger" v-if="errors.length">
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
        </div>

        <div class="field is-grouped is-grouped-right is-right">
          <div class="control">
            <button class="button is-submit-button">{{ $t('log_in') }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import { useMainStore } from '@/store';
import axios from 'axios'

export default {
  name: 'LogIn',
  data() {
    return {
      username: '',
      password: '',
      errors: []
    }
  },
  computed: {
    store: () => useMainStore()
  },
  methods: {
    submitForm() {
      const formData = {
        username: this.username,
        password: this.password
      }

      axios.post('/api/v1/admin/login/', formData)
          .then(async response => {
            const { token, username, id: userID } = response.data

            this.store.setToken(token)
            this.store.setUser({username, id: userID})

            try {
              await this.store.fetchUserPermissions()
              this.$router.push({name: 'VacationCalendar'})
            } catch (err) {
              this.errors.push('Failed to fetch user permissions.')
            }
          })
          .catch(error => {
            this.errors = [];
            if (error.response && typeof error.response.data === 'object') {
              for (const property in error.response.data) {
                this.errors.push(`${property}: ${error.response.data[property]}`);
              }
            } else if (error.message) {
              this.errors.push('Something went wrong. Please try again!');
            }

            setTimeout(() => {
              this.errors = [];
            }, 5000);
          })
    },
  }
}

</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--color-bg);
  flex-direction: column;
  padding: 1rem 0;
}

.login-box {
  display: flex;
  align-items: center;
  background: var(--color-card-bg);
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  border-top: 15px solid #4a1054;
  border-bottom: 15px solid #4a1054;
  width: 600px;
  position: relative;
}

.login-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
}

.logo {
  width: 90%;
  height: 50%;
}

.login-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.login-form .field {
  margin-bottom: 0.3rem;
  width: 100%;
}

.input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #e8f0fe;
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.3);
  font-size: 1rem;
}

.button.is-submit-button {
  background-color: #a5c800 !important;
  color: #4a1054;
  font-weight: bold;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.button.is-submit-button:hover {
  background-color: #92b500;
}

.alert.alert-danger {
  background-color: #ffdddd;
  color: #d8000c;
  border: 1px solid #d8000c;
  padding: 0.75rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  text-align: center;
  width: 100%;
}
</style>